export default __webpack_public_path__ + "static/media/girl dipressed.45b2d9b3.jpeg";